import React, { useState, useRef } from "react";
import styles from "./styles.css";
import ArrowIcon from "../arrow";
import { sendCustomGaEvents } from "../../../tracking";
import PropTypes from "prop-types";
import { NUMBER } from "../../../constants/app-constants";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const EChallaneTrafficRules = ({ trafficRules = {}, isDesktop = false, threshold = NUMBER.FIVE }) => {

    const [isCollapsed, setIsCollapsed] = useState(true);
    const listRef = useRef();

    const { title = "", description = "", trafficRulesList = [] } = trafficRules || {};

    const handleClick = async () => {
        if (!isCollapsed) {
            await yieldToMain();
            sendCustomGaEvents({
                event: "view_more_traffic_rules",
                eventAction: "View_more_traffic_rules",
                eventCategory: "Challan_homepage"
            });
        }
        setIsCollapsed(!isCollapsed);
    };

    const { tokens } = useTokens();

    const rulesList = (isCollapsed && !isDesktop) ? trafficRulesList.slice(0, threshold) : trafficRulesList;

    return (
        <div styleName={`styles.trafficRulesWrapper ${isDesktop ? "styles.trafficRulesWrapperDesktop" : ""}`} className="cvh">
            <Text size={"200"} fontWeight="semibold" color={tokens.text_default_text_primary} as="h2">{title}</Text>
            <Text size={isDesktop ? "250" : "200"} fontWeight="regular" color={tokens.text_default_text_secondary}>{description}</Text>
            <div styleName={`styles.rulesList`} ref={listRef}>
                {rulesList.map((item, index) => (
                    <div styleName={"styles.rulesText"} key={index}>
                        <Text fontWeight="medium" size="250" color={tokens.text_brand_text_accent}>{index + 1}</Text>
                        <Text as="h3" fontWeight="medium" size="250" color={tokens.text_default_text_primary}>{item.title}</Text>
                    </div>
                ))}
                {
                    !isDesktop && trafficRulesList.length > threshold &&
                    <div onClick={handleClick} styleName={"styles.readMore"}>
                        <span>
                            {!isCollapsed ? "view less" : "view more"}
                            <ArrowIcon rotateBy={isCollapsed ? NUMBER.NINETY : NUMBER.TWO_HUNDRED_SEVENTY} />
                        </span>
                    </div>
                }
            </div>
        </div>
    );
};

EChallaneTrafficRules.propTypes = {
    trafficRules: PropTypes.object,
    isDesktop: PropTypes.bool,
    threshold: PropTypes.number
};

export default EChallaneTrafficRules;
